import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { formatterNumbers } from '../../helpers';
import { DeltaInfo, FooterContainer, FooterItem } from './styles';
import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';
import { IndicatorPolygonIcon } from '~/icons';
import { colors } from '~/styles/colors';
import { EnergyTrendsData } from '../../types';

interface EnergyTrendsFooterProps {
  data: EnergyTrendsData | undefined;
}

interface EnergyFooterItemProps {
  title: string;
  percentage?: number | null;
  value?: number | null;
}

function PercentageIndicator(
  { percentage }: Readonly<{ percentage: number}>,
): ReactElement {
  const percentageBasedTotal = percentage - 100;
  const dangerPercentage = percentageBasedTotal > 0;

  return (
    <DeltaInfo redPercentage={dangerPercentage}>
      <IndicatorPolygonIcon
        color={dangerPercentage ? colors.state.danger.base : colors.state.success.base}
        rotate={dangerPercentage ? '60deg' : '0deg'}
      />
      <span>
        {formatNumberWithFractionDigits(percentageBasedTotal.toFixed(), { maximum: 0, minimum: 0 })}
        %
      </span>
    </DeltaInfo>
  );
}

function EnergyFooterItem({
  title,
  value,
  percentage,
}: Readonly<EnergyFooterItemProps>) {
  const numberValue = value ?? 0;
  const [formattedValue, unit] = formatterNumbers(numberValue);

  const isDefinedPercentage = percentage !== null && percentage !== undefined && value !== 0;

  return (
    <FooterItem>
      <h2>{title}</h2>
      <div>
        <p>
          {formattedValue}
          {' '}
          <span>
            {unit}
            h
          </span>
        </p>
        {isDefinedPercentage && (
        <PercentageIndicator percentage={percentage} />
        )}
      </div>
    </FooterItem>
  );
}

export function EnergyTrendsFooter({
  data,
}: Readonly<EnergyTrendsFooterProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <EnergyFooterItem
        title={t('metaMensal')}
        value={data?.monthlyTarget}
      />
      <EnergyFooterItem
        title={t('consumoProjetado')}
        value={data?.monthlyForecast}
        percentage={data?.monthlyForecastPercentage}
      />
      <EnergyFooterItem
        title={t('consumoAtual')}
        value={data?.totalConsumption}
        percentage={data?.totalConsumptionPercentage}
      />

    </FooterContainer>
  );
}
